export function formatPhone(phoneNumber: string | undefined) {
    const areaCode = phoneNumber?.slice(0, 3);
    const firstPart = phoneNumber?.slice(3, 6);
    const secondPart = phoneNumber?.slice(6, 10);
    return `(${areaCode}) ${firstPart}-${secondPart}`;
}

/**
 * Build an RFC 3966 compliant `tel:` href in E.164 form from any US phone
 * representation (raw digits or a formatted display string such as
 * "(888) 556-3483"). Non-digits are stripped, then a US country code is
 * applied: 10-digit numbers get a "+1" prefix, 11-digit numbers already
 * starting with "1" get a "+" prefix. Anything else falls back to the raw
 * digits with a leading "+". Returns an empty string for empty input.
 *
 * Examples:
 *   phoneToTelHref('(888) 556-3483') -> 'tel:+18885563483'
 *   phoneToTelHref('5555551234')     -> 'tel:+15555551234'
 *   phoneToTelHref('18885563483')    -> 'tel:+18885563483'
 */
export function phoneToTelHref(phoneNumber: string | undefined): string {
    const digits = (phoneNumber ?? '').replace(/\D/g, '');
    if (!digits) return '';
    if (digits.length === 10) return `tel:+1${digits}`;
    if (digits.length === 11 && digits.startsWith('1')) return `tel:+${digits}`;
    return `tel:+${digits}`;
}

export default formatPhone;
